var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSparkleReversed = function SvgSparkleReversed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 14c-4.875 0-7-2.051-7-7 0 4.949-2.11 7-7 7 4.89 0 7 2.11 7 7 0-4.89 2.125-7 7-7M21 5.5c-3.134 0-4.5-1.318-4.5-4.5 0 3.182-1.357 4.5-4.5 4.5 3.143 0 4.5 1.357 4.5 4.5 0-3.143 1.366-4.5 4.5-4.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15 14c-4.875 0-7-2.051-7-7 0 4.949-2.11 7-7 7 4.89 0 7 2.11 7 7 0-4.89 2.125-7 7-7ZM21 5.5c-3.134 0-4.5-1.318-4.5-4.5 0 3.182-1.357 4.5-4.5 4.5 3.143 0 4.5 1.357 4.5 4.5 0-3.143 1.366-4.5 4.5-4.5Z"
  })));
};
export default SvgSparkleReversed;